import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EventData } from "../../models/event";

const initialState: EventData = {
  id: "",
  name: "",
  description: "",
  is_custom_form: false,
  form_config: [],
  show_available_tickets: false,
  age_group: "",
  language: "",
  cover_image: "",
  category_id: "",
  visiblity: "public",
  feature_images: [],
  banner_image: "",
  video_url: "",
  permissions: { event_access: { permissions: [] } },
  dynamic_qr: false,
};

const eventSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    setSelectedEventList: (_, action: PayloadAction<EventData>) => {
      return action.payload;
    },
  },
});

export const { setSelectedEventList } = eventSlice.actions;
export default eventSlice.reducer;
